import { Component, Injector, Input, OnInit, WritableSignal, effect, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Itinerary, Leg, RouteFormResult } from '@features/planification-map/components/route-form/models/routeRequestResults.model';
import { LegDescription } from './models/step-description.model';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoPipe } from '@ngneat/transloco';
import { MatExpansionModule } from '@angular/material/expansion';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ResultsFooterService } from './services/results-footer.service';
import { ChartConfiguration, ChartOptions, } from "chart.js";
import { NgChartsModule } from 'ng2-charts';

@Component({
  selector: 'app-map-results-footer',
  standalone: true,
  imports: [CommonModule, MatIconModule, TranslocoPipe, MatExpansionModule, ReactiveFormsModule, FormsModule, NgChartsModule],
  templateUrl: './map-results-footer.component.html',
  styleUrls: ['./map-results-footer.component.scss']
})
export class MapResultsFooterComponent implements OnInit {

  @Input({required: true}) itinerarySelected!: WritableSignal<Itinerary|null>;
  @Input({required: true}) routeFormResult!: WritableSignal<RouteFormResult|null>;

  private resultsFooterService = inject(ResultsFooterService);

  public legsDescription: LegDescription[] = [];
  public itineraryElevation: any[] = [];
  public someLegOnBikeOrWalk = false;

  public lineChartData!: ChartConfiguration<"line">['data'] | null;
  public lineChartOptions: ChartOptions<'line'> = {
    maintainAspectRatio: false,
    responsive: true,
    scales: {
      x: {
        display: false,
      },
      y: {
        display: true,
        ticks: {
          callback: function(value) {
            return value + " m";
          },
          maxTicksLimit: 5,
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: false,
      }
    }
    
  };
  public lineChartLegend = true;

  constructor(private injector: Injector){}
  


  ngOnInit(): void {

    effect(() => {
      this.someLegOnBikeOrWalk = false;
      this.lineChartData = null;
      this.legsDescription = [];
      this.itineraryElevation = [];
      if(!this.itinerarySelected()) {
        return;
      }

      const origin = this.routeFormResult()?.requestParameters.fromDescription;
      const destination = this.routeFormResult()?.requestParameters.toDescription;
      if (!origin || !destination || !this.itinerarySelected()) return;
      this.legsDescription = this.resultsFooterService.getLegsDescriptionsFromItinerary(this.itinerarySelected() as Itinerary, origin, destination);
      this.getLegsElevation(this.itinerarySelected()?.legs as Leg[]);
    }, {injector: this.injector});
  }

  private getLegsElevation(legs: Leg[]) {
    this.itineraryElevation = [];
    const labels:number[] = [];
    let distance = 0;
    legs.forEach((leg:Leg) => {
      if(leg.mode === 'BICYCLE' || leg.mode === 'WALK') {
        this.someLegOnBikeOrWalk = true;
        if(leg.legElevation){
          const legElevations = leg.legElevation.split(",")
          legElevations.forEach((elevation, index) => {
            if (index % 2 === 0) {
              distance += Number(elevation);
              labels.push(distance);
            } else {
              this.itineraryElevation.push(Number(elevation));
            }
          })
        }
      } else if(leg.mode === "BUS") {
        this.itineraryElevation.push(null);
        labels.push(distance);
        distance += 10;	
        this.itineraryElevation.push(null);
        labels.push(distance);
        distance += 10;
        this.itineraryElevation.push(null);
        labels.push(distance);
        distance += 10;
      }
    })
    this.lineChartData = {
      labels: labels,
      datasets: [
        {
          data: this.itineraryElevation,
          label: 'Elevación',
          borderColor: '#CC0000',
          fill: true,
          pointRadius: 0,
        }
      ],
    }
  }

}
